export const sanitizeInput = (value, type = 'default') => {
  if (!value) return '';

  switch (type) {
    case 'digits':
      // Solo números
      return value.replace(/\D+/g, '');

    case 'noSpaces':
      // Elimina todos los espacios
      return value.replace(/\s+/g, '');

    case 'trim':
      // Quita espacios al inicio y final
      return value.trim();

    case 'email':
      // Sanitizar email: quitar acentos, ñ->n, mayúsculas->minúsculas
      return value
        .toLowerCase() // Convertir a minúsculas
        .replace(/ñ/g, 'n') // Sustituir ñ por n
        .replace(/[áàäâ]/g, 'a') // Sustituir acentos de a
        .replace(/[éèëê]/g, 'e') // Sustituir acentos de e
        .replace(/[íìïî]/g, 'i') // Sustituir acentos de i
        .replace(/[óòöô]/g, 'o') // Sustituir acentos de o
        .replace(/[úùüû]/g, 'u') // Sustituir acentos de u
        .trim(); // Quitar espacios al inicio y final

    case 'fullName':
      // Solo letras (incluyendo acentos y ñ/Ñ), y espacios
      return value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '');

    case 'alphanumeric':
      // Solo letras y números
      return value.replace(/[^a-zA-Z0-9]/g, '');

    case 'rfc':
      // Quitar caracteres no válidos, convertir a mayúsculas
      return value
        .replace(/[^A-Z0-9Ñ&]/gi, '')
        .toUpperCase()
        .trim();

    default:
      return value.trim();
  }
};
